import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../../../redux/hooks";
import { CustomDetailsList } from "../../../../../common/customDetailsList/customDetailsList";
import { Skeleton } from "../../../../../common/skeleton/skeleton";
import { MasterOrganismFormController } from "../controller/controller";
import { MasterOrganismColumns } from "./column/column";
import { SkeletonSizes } from "../../../../../../common/constants";
import { fetchMasterOrganismList } from "../../../../../../redux/actions/resources/master/organism/organism";

interface IMastersOrganismListContainer {
    widthPopUp: any;
    heigthPopUp: any;
}

export const MastersOrganismListContainer: React.FC<IMastersOrganismListContainer> = ({ heigthPopUp, widthPopUp }) => {
    const { list, loading } = useAppSelector((state) => state.masterOrganismList);
    const dispatch = useDispatch();
    const renderColumns = () => {
        return MasterOrganismColumns();
    };

    useEffect(() => {
        list === undefined && dispatch(fetchMasterOrganismList());
    }, [list]);

    return (
        <div style={{ height: "100%" }}>
            {loading ? (
                <Skeleton rows={SkeletonSizes.DEFAULT} />
            ) : (
                <CustomDetailsList
                    data={list ?? []}
                    renderColumns={renderColumns}
                    height={"calc(100vh - 10rem)"}
                />
            )}
            <MasterOrganismFormController
                widthPopUp={widthPopUp}
                heigthPopUp={heigthPopUp}
            />
        </div>
    );
};
